module.exports = __webpack_public_path__ + "static/media/order_icon13.e9989a49.png";